'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  id: null,
  link: null,
  name: null,
  slug: null,
  isDefaultLink: false
}, 'MeetingsLink');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/data/records/MeetingsLink.js
// module id = 287
// module chunks = 0 1